import { LOCALE_KEY } from "../common/consts";
import { ELocales } from "../common";
import { TLang } from "./types";

export const getLocale = () => {
  return (localStorage.getItem(LOCALE_KEY) as TLang) || "ua";
};
